export default {
  strict: true,
  namespaced: true,
  state: {
    list: {},
    loading: false,
    // selected: 'USD',
    // symbol: '$',
    // value: 1,
    lastUpdate: ''
  },
  mutations: {
    setCurrencyData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/currency/index.js